import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { Language } from "@mui/icons-material";

import { styles } from "../styles";

interface MmsiInfoDialogProps {
  open: boolean;
  onClose: () => void;
}

function MmsiInfoDialog({ open, onClose }: MmsiInfoDialogProps) {
  return (
    <Dialog
      aria-describedby="edit-boat-dialog-mmsi-description"
      aria-labelledby="edit-boat-dialog-mmsi-title"
      maxWidth="xs"
      open={open}
      sx={{ maxHeight: "570px", alignSelf: "center" }}
      onClose={onClose}
    >
      <DialogTitle id="alert-dialog-title" sx={styles.dialogTitle}>
        MMSI
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Typography sx={{ color: "text.secondary" }} variant="body1">
          A MMSI (Maritime Mobile Service Identity) number is a unique nine-digit identifier
          assigned to vessels and used to track them through AIS (Automatic Identification System).
        </Typography>
        <Typography sx={{ color: "text.secondary", marginTop: 4 }} variant="body1">
          If you operate only in U.S. waters you can obtain an MMSI from:
        </Typography>
        <Box
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: "16px",
            overflow: "hidden",
            mb: 2,
            mt: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 2,
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            <Typography sx={{ fontWeight: 600 }}>BoatU.S. (Free for members)</Typography>
            <a
              href="https://www.boatus.com/products-and-services/membership/mmsi"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Box component="span" sx={{ display: "flex", alignItems: "center" }}>
                <Language sx={{ color: "primary.main" }} />
              </Box>
            </a>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: 2,
            }}
          >
            <Box>
              <Typography sx={{ fontWeight: 600 }}>U.S. Power Squadrons</Typography>
              <Typography sx={{ fontWeight: 600 }}>(America&apos;s Boating Club)</Typography>
            </Box>
            <a href="https://www.usps.org/php/mmsi_new/" rel="noopener noreferrer" target="_blank">
              <Box component="span" sx={{ display: "flex", alignItems: "center" }}>
                <Language sx={{ color: "primary.main" }} />
              </Box>
            </a>
          </Box>
        </Box>
        <Typography sx={{ color: "text.secondary", marginTop: 4 }} variant="caption">
          If your vessel travels internationally you must obtain an MMSI through the FCC (Federal
          Communications Commission):{" "}
          <a href="https://fcc.gov/wireless" rel="noreferrer" target="_blank">
            fcc.gov/wireless
          </a>
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", py: 3 }}>
        <Button variant="contained" onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MmsiInfoDialog;
